export { default as RemoveFromWishlistButton } from './RemoveFromWishlistButton';
